module.exports = __webpack_public_path__ + "static/media/ic_sound.b2d12b4b.svg";